var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1954_1714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.42862 3.17853H2.67862C2.11031 3.17853 1.56526 3.40429 1.1634 3.80616C0.761532 4.20802 0.535767 4.75307 0.535767 5.32139V12.8214C0.535767 13.3897 0.761532 13.9347 1.1634 14.3366C1.56526 14.7385 2.11031 14.9642 2.67862 14.9642H10.1786C10.7469 14.9642 11.2919 14.7385 11.6938 14.3366C12.0957 13.9347 12.3215 13.3897 12.3215 12.8214V9.07139",
    stroke: "#EFFEF5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7857 6.39291C13.2651 6.39291 14.4643 5.19367 14.4643 3.71434C14.4643 2.23501 13.2651 1.03577 11.7857 1.03577C10.3064 1.03577 9.10718 2.23501 9.10718 3.71434C9.10718 5.19367 10.3064 6.39291 11.7857 6.39291Z",
    stroke: "#EFFEF5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1954_1714"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationActive);
export default __webpack_public_path__ + "static/media/notification-active.46a75e3f83c7b5084795cafaa7dd6c4f.svg";
export { ForwardRef as ReactComponent };